import { render, staticRenderFns } from "./AiChatPanel.vue?vue&type=template&id=1edd111e&scoped=true"
import script from "./AiChatPanel.vue?vue&type=script&lang=js"
export * from "./AiChatPanel.vue?vue&type=script&lang=js"
import style0 from "./AiChatPanel.vue?vue&type=style&index=0&id=1edd111e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edd111e",
  null
  
)

export default component.exports